import { useSelector } from 'react-redux';

import { selectConfig, selectIsPreinstall } from '@app/redux';

import { GetPlanOffersPayload, RetentionOffer } from '@mfe/shared/schema-types';

export const useHasOffersToDisplay = (
  retentionOffers: RetentionOffer[] | null,
  planOffersData: GetPlanOffersPayload[] | null,
  hasActiveRetentionOffer: boolean
): boolean => {
  const hasPreinstall = useSelector(selectIsPreinstall);
  const hasPlanOffers = hasOffers(planOffersData);
  const hasRetentionOffers = hasOffers(retentionOffers);

  if (hasPreinstall) {
    return false;
  }

  return hasPlanOffers || (hasRetentionOffers && !hasActiveRetentionOffer);

  function hasOffers(data: RetentionOffer[] | GetPlanOffersPayload[] | null): boolean {
    return Boolean(data && data.length && data.length > 0);
  }
};
